/**
 * Column definitions for Monthly Usage spend table (mirrors backend monthlyUsageColumns.js).
 */
export const MONTHLY_USAGE_COLUMNS = [
  {
    key: 'billingGroup',
    label: 'Billing Group',
    description: 'Cursor billing group name'
  },
  {
    key: 'members',
    label: 'Members',
    description: 'Active members in the group this month'
  },
  {
    key: 'monthlySpend',
    label: 'Monthly Spend',
    description: 'Spend for the selected report month (month-to-date if in progress)'
  },
  {
    key: 'yearlyPrepaid',
    label: 'Yearly Prepaid',
    description: 'Admin-configured committed prepaid for the fiscal year'
  },
  {
    key: 'ytdConsumed',
    label: 'YTD Consumed',
    description: 'Total spend from fiscal year start through this month; % shows draw-down vs prepaid'
  },
  {
    key: 'usageTrend',
    label: 'Usage Trend',
    description: 'Compares YTD consumed to linear prepaid pace; prorated by days when month is in progress'
  },
  {
    key: 'status',
    label: 'Status',
    description: 'Final = month closed; In Progress = month-to-date figures'
  }
];
